import { CountryDefintion, recognisedCountries } from './countryDefinitions.js';

export const countries: Array<CountryDefintion> = [
  recognisedCountries.AUSTRALIA,
  recognisedCountries.AUSTRIA,
  recognisedCountries.BAHRAIN,
  recognisedCountries.BARBADOS,
  recognisedCountries.BELGIUM,
  recognisedCountries.BERMUDA,
  recognisedCountries.BOTSWANA,
  recognisedCountries.BRAZIL,
  recognisedCountries.BRUNEI_DARUSSALAM,
  recognisedCountries.BULGARIA,
  recognisedCountries.CANADA,
  recognisedCountries.CAYMAN_ISLANDS,
  recognisedCountries.CHILE,
  recognisedCountries.CHINA,
  recognisedCountries.COLOMBIA,
  recognisedCountries.COSTA_RICA,
  recognisedCountries.CROATIA,
  recognisedCountries.CYPRUS,
  recognisedCountries.CZECH_REPUBLIC,
  recognisedCountries.DENMARK,
  recognisedCountries.ESTONIA,
  recognisedCountries.FINLAND,
  recognisedCountries.FRANCE,
  recognisedCountries.GERMANY,
  recognisedCountries.GREECE,
  recognisedCountries.HUNGARY,
  recognisedCountries.INDIA,
  recognisedCountries.INDONESIA,
  recognisedCountries.IRAN_ISLAMIC_REPUBLIC_OF,
  recognisedCountries.IRELAND,
  recognisedCountries.ISRAEL,
  recognisedCountries.ITALY,
  recognisedCountries.JAPAN,
  recognisedCountries.KENYA,
  recognisedCountries.NORTH_KOREA,
  recognisedCountries.SOUTH_KOREA,
  recognisedCountries.KUWAIT,
  recognisedCountries.LATVIA,
  recognisedCountries.LITHUANIA,
  recognisedCountries.LUXEMBOURG,
  recognisedCountries.MALAYSIA,
  recognisedCountries.MALTA,
  recognisedCountries.MEXICO,
  recognisedCountries.NETHERLANDS,
  recognisedCountries.NEW_ZEALAND,
  recognisedCountries.NORWAY,
  recognisedCountries.OMAN,
  recognisedCountries.PAKISTAN,
  recognisedCountries.PHILIPPINES,
  recognisedCountries.POLAND,
  recognisedCountries.PORTUGAL,
  recognisedCountries.QATAR,
  recognisedCountries.ROMANIA,
  recognisedCountries.SAUDI_ARABIA,
  recognisedCountries.SINGAPORE,
  recognisedCountries.SLOVAKIA,
  recognisedCountries.SLOVENIA,
  recognisedCountries.SOUTH_AFRICA,
  recognisedCountries.SPAIN,
  recognisedCountries.SWEDEN,
  recognisedCountries.SWITZERLAND,
  recognisedCountries.TAIWAN,
  recognisedCountries.THAILAND,
  recognisedCountries.TUNISIA,
  recognisedCountries.TURKEY,
  recognisedCountries.UNITED_ARAB_EMIRATES,
  recognisedCountries.UNITED_KINGDOM,
  recognisedCountries.UNITED_STATES_OF_AMERICA,
  recognisedCountries.VIETNAM,
  recognisedCountries.ZAMBIA,
  recognisedCountries.EGYPT,
  recognisedCountries.SRI_LANKA,
  recognisedCountries.MOROCCO,
  recognisedCountries.NIGERIA,
  recognisedCountries.NIGER,
  recognisedCountries.GHANA,
  recognisedCountries.BANGLADESH,
  recognisedCountries.PERU,
  recognisedCountries.VENEZUELA,
  recognisedCountries.ICELAND,
  recognisedCountries.CAMBODIA,
  recognisedCountries.BOLIVIA,
  recognisedCountries.URUGUAY,
  recognisedCountries.JORDAN,
  recognisedCountries.LIECHTENSTEIN,
  recognisedCountries.MACAU,
  recognisedCountries.MOLDOVA_REPUBLIC_OF,
  recognisedCountries.MONACO,
  recognisedCountries.NEPAL,
  recognisedCountries.SENEGAL,
  recognisedCountries.UZBEKISTAN,
  recognisedCountries.FIJI,
  recognisedCountries.BURUNDI,
  recognisedCountries.BENIN,
  recognisedCountries.CHAD,
  recognisedCountries.DJIBOUTI,
  recognisedCountries.ERITREA,
  recognisedCountries.GABON,
  recognisedCountries.LIBERIA,
  recognisedCountries.MAURITIUS,
  recognisedCountries.RWANDA,
  recognisedCountries.SIERRA_LEONE,
  recognisedCountries.SOMALIA,
  recognisedCountries.SWAZILAND,
  recognisedCountries.YEMEN,
  recognisedCountries.MALAWI,
  recognisedCountries.ZIMBABWE,
  recognisedCountries.MYANMAR,
  recognisedCountries.LAOS,
  recognisedCountries.NAMIBIA,
  recognisedCountries.BAHAMAS,
  recognisedCountries.GUATEMALA,
  recognisedCountries.HONDURAS,
  recognisedCountries.EL_SALVADOR,
  recognisedCountries.CUBA,
  recognisedCountries.JAMAICA,
  recognisedCountries.TRINIDAD_AND_TOBAGO,
  recognisedCountries.DOMINICAN_REPUBLIC,
  recognisedCountries.PARAGUAY,
  recognisedCountries.FAROE_ISLANDS,
  recognisedCountries.GREENLAND,
  recognisedCountries.ISLE_OF_MAN,
  recognisedCountries.JERSEY,
  recognisedCountries.GUERNSEY,
  recognisedCountries.SAINT_LUCIA,
  recognisedCountries.ANGUILLA,
  recognisedCountries.COOK_ISLANDS,
  recognisedCountries.GIBRALTAR,
  recognisedCountries.MONTENEGRO,
  recognisedCountries.SAINT_VINCENT_AND_THE_GRENADINES,
  recognisedCountries.TURKS_AND_CAICOS_ISLANDS,
  recognisedCountries.NORTH_MACEDONIA_REPUBLIC_OF,
  recognisedCountries.SAINT_KITTS_AND_NEVIS,
  recognisedCountries.ANTIGUA_AND_BARBUDA,
  recognisedCountries.DOMINICA,
  recognisedCountries.HONG_KONG,
  recognisedCountries.KAZAKHSTAN,
  recognisedCountries.SERBIA,
  recognisedCountries.AFGHANISTAN,
  recognisedCountries.ALBANIA,
  recognisedCountries.ALGERIA,
  recognisedCountries.AMERICAN_SAMOA,
  recognisedCountries.ANDORRA,
  recognisedCountries.ANGOLA,
  recognisedCountries.ANTARCTICA,
  recognisedCountries.ARGENTINA,
  recognisedCountries.ARMENIA,
  recognisedCountries.ARUBA,
  recognisedCountries.AZERBAIJAN,
  recognisedCountries.BELARUS,
  recognisedCountries.BELIZE,
  recognisedCountries.BHUTAN,
  recognisedCountries.BOSNIA_AND_HERZEGOVINA,
  recognisedCountries.BOUVET_ISLAND,
  recognisedCountries.BRITISH_INDIAN_OCEAN_TERRITORY,
  recognisedCountries.BURKINA_FASO,
  recognisedCountries.CAMEROON,
  recognisedCountries.CAPE_VERDE,
  recognisedCountries.CENTRAL_AFRICAN_REPUBLIC,
  recognisedCountries.CHRISTMAS_ISLAND,
  recognisedCountries.COCOS_KEELING_ISLANDS,
  recognisedCountries.COMOROS,
  recognisedCountries.CONGO,
  recognisedCountries.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  recognisedCountries.ECUADOR,
  recognisedCountries.EQUATORIAL_GUINEA,
  recognisedCountries.ETHIOPIA,
  recognisedCountries.FALKLAND_ISLANDS_MALVINAS,
  recognisedCountries.FRENCH_GUIANA,
  recognisedCountries.FRENCH_POLYNESIA,
  recognisedCountries.FRENCH_SOUTHERN_TERRITORIES,
  recognisedCountries.GAMBIA,
  recognisedCountries.GEORGIA,
  recognisedCountries.GRENADA,
  recognisedCountries.GUADELOUPE,
  recognisedCountries.GUAM,
  recognisedCountries.GUINEA,
  recognisedCountries.GUINEA_BISSAU,
  recognisedCountries.GUYANA,
  recognisedCountries.HAITI,
  recognisedCountries.HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  recognisedCountries.VATICAN,
  recognisedCountries.IRAQ,
  recognisedCountries.KIRIBATI,
  recognisedCountries.KYRGYZSTAN,
  recognisedCountries.LEBANON,
  recognisedCountries.LESOTHO,
  recognisedCountries.LIBYA,
  recognisedCountries.MADAGASCAR,
  recognisedCountries.MALDIVES,
  recognisedCountries.MALI,
  recognisedCountries.MARSHALL_ISLANDS,
  recognisedCountries.MARTINIQUE,
  recognisedCountries.MAURITANIA,
  recognisedCountries.MAYOTTE,
  recognisedCountries.MICRONESIA_FEDERATED_STATES_OF,
  recognisedCountries.MONGOLIA,
  recognisedCountries.MONTSERRAT,
  recognisedCountries.MOZAMBIQUE,
  recognisedCountries.NAURU,
  recognisedCountries.NEW_CALEDONIA,
  recognisedCountries.NICARAGUA,
  recognisedCountries.NIUE,
  recognisedCountries.NORFOLK_ISLAND,
  recognisedCountries.NORTHERN_MARIANA_ISLANDS,
  recognisedCountries.PALAU,
  recognisedCountries.PALESTINE,
  recognisedCountries.PANAMA,
  recognisedCountries.PAPUA_NEW_GUINEA,
  recognisedCountries.PITCAIRN,
  recognisedCountries.PUERTO_RICO,
  recognisedCountries.REUNION,
  recognisedCountries.RUSSIA,
  recognisedCountries.SAINT_HELENA,
  recognisedCountries.SAINT_PIERRE_AND_MIQUELON,
  recognisedCountries.SAMOA,
  recognisedCountries.SAN_MARINO,
  recognisedCountries.SAO_TOME_AND_PRINCIPE,
  recognisedCountries.SEYCHELLES,
  recognisedCountries.SOLOMON_ISLANDS,
  recognisedCountries.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  recognisedCountries.SUDAN,
  recognisedCountries.SURINAME,
  recognisedCountries.SVALBARD_AND_JAN_MAYEN,
  recognisedCountries.SYRIA,
  recognisedCountries.TAJIKISTAN,
  recognisedCountries.TANZANIA_UNITED_REPUBLIC_OF,
  recognisedCountries.TIMOR_LESTE,
  recognisedCountries.TOGO,
  recognisedCountries.TOKELAU,
  recognisedCountries.TONGA,
  recognisedCountries.TURKMENISTAN,
  recognisedCountries.TUVALU,
  recognisedCountries.UGANDA,
  recognisedCountries.UKRAINE,
  recognisedCountries.UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  recognisedCountries.VANUATU,
  recognisedCountries.VIRGIN_ISLANDS_BRITISH,
  recognisedCountries.VIRGIN_ISLANDS_US,
  recognisedCountries.WALLIS_AND_FUTUNA,
  recognisedCountries.WESTERN_SAHARA,
  recognisedCountries.ALAND_ISLANDS,
  recognisedCountries.BONAIRE_SINT_EUSTATIUS_AND_SABA,
  recognisedCountries.CURACAO,
  recognisedCountries.SAINT_BARTHELEMY,
  recognisedCountries.SAINT_MARTIN_FRANCE,
  recognisedCountries.SINT_MAARTEN_DUTCH,
  recognisedCountries.SOUTH_SUDAN,
  recognisedCountries.KOSOVO,
  recognisedCountries.COTE_DIVOIRE,
];
